<template>
    <div>
        <modal :name="modal_name" class="final-modal signature-status merge-modal-quotation top-70" transition="nice-modal-fade" :clickToClose="false">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="v-modal-header" style="background:#f0ddb7 !important;">
                    <span class="v-modal-dialog-title v-modal-title  text-black text-center" style="text-transform:none !important;">Discard Ticket</span>
                </div>
                <div class="general-section pt-2 pl-0 pr-0 pb-1" style="background-color:#fff;border-radius:0px">
                    <div class="p-0" style="max-height: 410px;overflow-x: hidden;overflow-y: auto;">
                        <div class="text-center w-100">
                            <i class="icon icon-information-outline text-danger fs-30 d-block" style="color: #7e9cbf; height: auto !important; line-height: 1 !important; width: auto !important;"></i>
                            <h1 class="fs-20 fw-600">Alert !</h1>
                        </div>
                        <div class="w-100 px-3">
                            <p class="fs-14 text-black">Reason for Discarding the Ticket <sup class="text-danger"><span class="fs-16">*</span></sup></p>
                            <textarea class="discard-ticket-text-area w-100" name="discard_reason" rows="5" v-model="discard_reason" v-validate="'required'" maxlength="1000"></textarea>
                            <span class="text-right">{{ discard_reason.length }}  / 1000 </span>
                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('discard_reason')">{{ errors.first("discard_reason") }}</span>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions mt-2" style="border-radius: 0px 0px 15px 15px;">
                        <button class="btn btn-danger-new mb-2" style="text-transform: capitalize !important;font-size: 12px !important; border-radius: 5px !important;" @click="hideView()">Cancel</button>
                        <button type="button" class="btn btn-green mb-2 ml-4" @click="save()" :disabled="save_loader" style="box-shadow: none;">
                            Save
                            <div class="digi-table-loader digi-button-loader-pos" v-if = "save_loader" >
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event.js';
import ticket from '../mixins/ticket.js';
import { SweetModal } from 'sweet-modal-vue'
export default {
    props:['modal_name', 'showDetails'],
    mixins:[ticket],
    data(){
        return{
            save_loader: false,
            discard_reason: '',
            attachments:[],
            success_msg:'',
            warning_msg:'',
        }
    },
    components:{
        SweetModal
    },
    methods:{
        hideView(){
            // this.$modal.hide(this.modal_name);
            this.$emit('hideDiscardTicket');
            EventBus.$emit('ZindexChangeEnd')
        },
        save(){
            this.$validator.validateAll().then(result => {
                if(result) {
                    let params ={
                        "status": "discard",
                        "discard_reason": this.discard_reason,
                        "ticket_id":this.showDetails.ticket_id
                    }
                    this.confirmSave(params)
                }
            })
            
        },
        async confirmSave(params){
            try {
                this.save_loader = true
                let res = await this.changeStatus(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                this.$emit('updateDiscardStatus')
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$modal.hide(this.modal_name);
                    this.save_loader = false
                }, 2000);
                EventBus.$emit('ZindexChangeEnd')
            } catch (reason) {
                this.save_loader = false
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
    },
    mounted() {
        
    },
    created() {
        const dict = {
            custom: {
                discard_reason:{
                    required:() => "Reason for Discard is Required",
                },
            }
        }
        this.$validator.localize("en", dict);
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    },
    watch:{
        
    },
}
</script>
<style scoped>
.digi-button-loader-pos{
    position: absolute;
    width: 24px;
    height: 64px;
    top: -14px;
}
.serviceticket{
    background-color: #ecf5ff;
    padding: 10px 15px;
    margin: 10px 0px;
	font-family: 'Poppins', sans-serif !important;
}
.statushead{
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #616161;
}
.statustext{
  font-size: 14px;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: left;
  font-weight: 500 !important;
  color: #005dae;
}
.signaturebg{
    background-color: #ffffff;
    width: 70%;
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.3px #f5a623;
}
.p-description-mail {
    white-space: normal !important;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: #4e5764;
    margin-bottom: 30px;
    padding-left: 32px;
}
.p-description-mail {
    overflow-y: visible !important;
    overflow-x: scroll;
}
.w-80{
    width: 80% !important;
}
.description-content{
    line-break: anywhere;
    white-space: pre-wrap;
}
.discard-ticket-text-area {
    padding: 12px;
    border-radius: 7.5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #cdd2da;
    background-color: #fff;
}
</style>